import BaseApi from "./BaseApi";
import qs from "qs";

export const getPaymentUrl = async reqObj => {
  const reqStr = qs.stringify(reqObj, { allowDots: true, encode: false });
  const result = await BaseApi.get(`/Payment/GetPaymentUrl/?${reqStr}`);
  return result;
};

export const setReservationUrl = async reqObj => {
  const result = await BaseApi.post(`/Payment/SetReservation`, reqObj);
  return result;
};

export const payPalProxyApi = async reqObj => {
  const reqStr = qs.stringify(reqObj, { allowDots: true, encode: false });
  const result = await BaseApi.get(`/Payment/GetPayPalProxy/?${reqStr}`);
  return result;
};



// WEBPACK FOOTER //
// ./src/api/payment.js